<template>
<div id ="tag-edit">
  <tag-form
    :tagId="tagId"
  ></tag-form>
</div>
</template>

<script>
import TagForm from '@/components/TagForm'

export default {
  components: {
    'tag-form': TagForm
  },

  props: ['tagId']
}
</script>



// WEBPACK FOOTER //
// src/components/TagEdit.vue